import { AxiosError, AxiosResponse } from "axios";
import Core from "../core";

async function reportsTo(company_id: number, employee_id: number) {
  const api = Core.getInstance().api();
  const data = await api.get(
    `/v1/getMyManager?companyId=${company_id}&empId=${employee_id}&full_path=true&locale=${localStorage.getItem(
      "emplang"
    )}`
  );
  if (data instanceof AxiosError) {
    return data.response;
  }

  const response = data.data;
  return response;
}

export const reportsToService = {
  reportsTo,
};
